"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ItemCollection = _interopRequireDefault(require("../ItemCollection"));

var _Review = _interopRequireDefault(require("../../molecules/Review"));

var Reviews = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Reviews, _React$Component);

  function Reviews() {
    (0, _classCallCheck2["default"])(this, Reviews);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Reviews).apply(this, arguments));
  }

  (0, _createClass2["default"])(Reviews, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          reviews = _this$props.reviews,
          header = _this$props.header,
          itemsPerRow = _this$props.itemsPerRow,
          itemsDivided = _this$props.itemsDivided,
          centerHeader = _this$props.centerHeader,
          onlyEvenRows = _this$props.onlyEvenRows,
          as = _this$props.as,
          cardInlinePhoto = _this$props.cardInlinePhoto,
          imageCircular = _this$props.imageCircular,
          imageSize = _this$props.imageSize,
          showImage = _this$props.showImage,
          itemButtonFloat = _this$props.itemButtonFloat,
          itemCenterContent = _this$props.itemCenterContent,
          linkAs = _this$props.linkAs,
          verticalItemAlign = _this$props.verticalItemAlign;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ItemCollection["default"], {
        header: header,
        collectionType: as === 'horizontalItem' ? 'items' : 'custom',
        itemsPerRow: itemsPerRow,
        itemsDivided: itemsDivided,
        centerHeader: centerHeader,
        onlyEvenRows: onlyEvenRows
      }, reviews.map(function (review) {
        return _react["default"].createElement(_Review["default"], (0, _extends2["default"])({}, review, {
          key: review.name,
          image: showImage && review.image,
          as: as,
          cardInlinePhoto: cardInlinePhoto,
          imageCircular: imageCircular,
          imageSize: imageSize,
          itemButtonFloat: itemButtonFloat,
          itemCenterContent: itemCenterContent,
          linkAs: linkAs,
          verticalItemAlign: verticalItemAlign
        }));
      })));
    }
  }]);
  return Reviews;
}(_react["default"].Component);

exports["default"] = Reviews;
Reviews.propTypes = {
  reviews: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    company: _propTypes["default"].string,
    content: _propTypes["default"].string.isRequired,
    image: _propTypes["default"].string,
    link: _propTypes["default"].string,
    linkContent: _propTypes["default"].string
  })).isRequired,
  as: _propTypes["default"].oneOf(['verticalItem', 'horizontalItem', 'card']),
  buttonBasic: _propTypes["default"].bool,
  buttonSize: _propTypes["default"].string,
  cardInlinePhoto: _propTypes["default"].oneOf(['left', false]),
  centerHeader: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  imageCircular: _propTypes["default"].bool,
  imageSize: _propTypes["default"].string,
  itemButtonFloat: _propTypes["default"].oneOf(['left', 'right']),
  itemCenterContent: _propTypes["default"].bool,
  itemsDivided: _propTypes["default"].bool,
  itemsPerRow: _propTypes["default"].number,
  linkAs: _propTypes["default"].oneOf(['button', 'header', 'none']),
  onlyEvenRows: _propTypes["default"].bool,
  showImage: _propTypes["default"].bool,
  verticalItemAlign: _propTypes["default"].oneOf(['left', 'right', 'center'])
};
Reviews.defaultProps = {
  header: 'Reviews',
  as: 'horizontalItem',
  buttonBasic: false,
  buttonSize: 'medium',
  cardInlinePhoto: false,
  imageCircular: false,
  imageSize: 'small',
  showImage: true,
  itemButtonFloat: 'left',
  itemCenterContent: false,
  linkAs: 'none',
  itemsPerRow: 3,
  itemsDivided: false,
  centerHeader: false,
  onlyEvenRows: false,
  verticalItemAlign: 'center'
};
Reviews.propOptions = {};
Reviews.dataPropsMap = {
  reviews: ['business', 'reviews']
};